import { render, staticRenderFns } from "./myCourses.vue?vue&type=template&id=2c1d45f8&scoped=true"
import script from "./myCourses.vue?vue&type=script&lang=js"
export * from "./myCourses.vue?vue&type=script&lang=js"
import style0 from "./myCourses.vue?vue&type=style&index=0&id=2c1d45f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d45f8",
  null
  
)

export default component.exports